export enum GlobalTextAlign {
  AlignLeft = 'align-left',
  AlignRight = 'align-right',
  AlignCenter = 'align-center',
}
